/**
 * Types for the per-user UI preferences store
 * (`apps/orgs/services/user_preferences.py` § "Boundary rule").
 *
 * Boundary rules:
 * (a) Membership PATCH prefs (`time_format`, `digest_cadence`, ...), keyed
 *     `MEMBERSHIP_PREFERENCES_QUERY_KEY` in `useUserProfileData.ts`, are a
 *     separate, agent/notification-facing store on `OrgMembership`. This
 *     module is UI-only preferences — never shared across users, never
 *     agent-visible.
 * (b) Column order/visibility is NOT a preference here — it lives on a
 *     saved view's `view_state` (`SavedFilterViewState` in
 *     `@/types/savedFilterView`). Users who want durable columns create a
 *     saved view.
 */

export const PREF_LIST_DEFAULT_VIEW = 'list_default_view';

/** Value shape for the `PREF_LIST_DEFAULT_VIEW` preference. */
export interface ListDefaultViewPref {
  kind: 'saved' | 'builtin' | 'all';
  id?: string;
}

/** One row as returned by the preferences API. */
export interface UserPreferenceRow {
  key: string;
  scope: string;
  value: unknown;
  updated_at: string;
}
